export const buildTextSearch = (searchTerm, exactMatch = false) => {
  return exactMatch ? `"${searchTerm}"` : searchTerm;
}